<div class="footer">
    <footer class="bg-dark text-white">
      <div class="container">
        <nav class="row">
          <a href="#" class="col-3 text-reset text-uppercase d-flex align-items-center">
            <img src="https://cdn.iconscout.com/icon/free/png-512/koala-bear-lazy-honey-wild-animal-33903.png" alt="Logo koalas" width="60" height="60" class="img-logo mr-2">Koalas lovers
          </a>
          <ul class="col-3 list-unstyled">
            <li class="font-weight-bold text-uppercase">About our team</li>
            <br>
            <p><b>Koala´s Team</b> construye tu nueva comunidad en tan sólo un segundo. No dudes en probar gratuitamente nuestra KoalaApp</p>
          </ul>
          <ul class="col-3 list-unstyled">
            <li class="font-weight-bold text-uppercase">Legal Terms</li>
            <li><a href="legal-terms" class="text-reset name-terms">Legal Terms</a></li>
            <li><a href="privacy-policy" class="text-reset name-terms">Privacy Policy</a></li>
            <li><a href="cookies-policy" class="text-reset name-terms">Cookies Policy</a></li>
            <li><a href="legal-notice" class="text-reset name-terms">Legal Notice</a></li>
          </ul>
          <ul class="col-3 list-unstyled">
            <li class="font-weight-bold text-uppercase">Follow us</li>
            <li class="justify-content">
              <a href="https://twitter.com/karmickoala1" target="_blank" class="text-reset">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/karmickoala1" target="_blank" class="text-reset">
                <i class="fab fa-instagram ml-2"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  </div>
  